<template>
  <div class="container col-jj">
    <!--橙联介绍 Orange Connex-->
    <div class="tracking03_mod"></div>
    <div class="container">
      <div class="col-md-12">
        <div class="container">
          <div class="tracking03_pic col-md-12">
            <h4>{{ $t('tracking.ProductsPricing') }}</h4>
            <p>{{ $t('tracking.SearchPrice') }}</p>
            <a @click="toSpeedPAK">{{ $t('tracking.SpeedPAK') }}</a>
            <a @click="toSpeedFreight">{{ $t('tracking.ConsolFreight') }}</a>
            <!-- <a @click="toSpeedFreightAsia" v-html="$t('tracking.ConsolFreight2')" v-if="$i18n.locale === 'zh-CN'"></a>
            <a
              @click="toSpeedFreightAsia"
              v-html="$t('tracking.ConsolFreight2')"
              v-else
              style="text-align: center;font-size: 14px;line-height: 14px;height: 42px;vertical-align: bottom;"
            ></a> -->
            <a @click="toMc">{{$t('product.multiChannel.title') }}</a>
          </div>
        </div>
        <div>
          <div class="container">
            <div class="col-md-12" v-show="showSpeedPAK">
              <span class="tracking03_btn" v-show="!dlpriceCalcMouseOver" @mouseover="dlmouseOver" @mouseleave="dlmouseLeave">
                <a @click="dlPriceCardDownload" >{{ $t('tracking.tracking03.dlPriceCard') }}</a>
              </span>
              <span class="tracking03_mouseover_btn"  v-show="dlpriceCalcMouseOver" @mouseover="dlmouseOver" @mouseleave="dlmouseLeave">
                  <a @click="dlPriceCardDownload" >{{ $t('tracking.tracking03.dlPriceCard') }}</a>
              </span>
              <span class="tracking03_btn" v-show="!hkpriceCalcMouseOver" @mouseover="hkmouseOver" @mouseleave="hkmouseLeave">
                <a @click="hkPriceCardDownload" >{{ $t('tracking.tracking03.hkPriceCard') }}</a>
              </span>
              <span class="tracking03_mouseover_btn"  v-show="hkpriceCalcMouseOver" @mouseover="hkmouseOver" @mouseleave="hkmouseLeave">
                <a @click="hkPriceCardDownload" >{{ $t('tracking.tracking03.hkPriceCard') }}</a>
              </span>
<!--              <a @click="dlMiniPriceCardDownload">{{ $t('tracking.tracking03.dlMiniPriceCard') }}</a>-->
              <span >
                <span class="tracking03_btn" v-show="!priceCalcMouseOver" @mouseover="mouseOver" @mouseleave="mouseLeave">
                  <a @click="spkPriceCalculator"  icon="ios-calculator"  >{{ $t('tracking.tracking03.spkPriceCalculator') }}</a>
                </span>
                <span class="tracking03_mouseover_btn"  v-show="priceCalcMouseOver" @mouseover="mouseOver" @mouseleave="mouseLeave">
                  <a @click="spkPriceCalculator"   icon="ios-calculator"  >{{ $t('tracking.tracking03.spkPriceCalculator') }}</a>
                </span>
              </span>

              <!--<div v-show="$i18n.locale === 'zh-CN'" @mouseover="mouseOver" @mouseleave="mouseLeave" style="width: 260px">
                <div class="tracking03_btn" v-show="!priceCalcMouseOver">
                  <a @click="spkPriceCalculator" icon="ios-calculator"  >{{ $t('tracking.tracking03.spkPriceCalculator') }}</a>
                </div>
                <div class="tracking03_mouseover_btn" v-show="priceCalcMouseOver">
                  <a @click="spkPriceCalculator" icon="ios-calculator"  >{{ $t('tracking.tracking03.spkPriceCalculator') }}</a>
                </div>
              </div>-->
            </div>

            <div class="tracking03_btn col-md-12" v-show="showSpeedFreight">
              <a @click="spfPriceCardDownload">{{ $t('tracking.tracking03.spfPriceCard') }}</a>
            </div>
            <div class="tracking03_btn col-md-12" v-show="showSpeedFreightAsia">
              <!-- <a @click="spfAsiaPriceCardDownload" v-html="$t('tracking.tracking03.spfAsiaPriceCard')" style="text-align:center"></a> -->
            </div>
             <div class="tracking03_btn col-md-12" v-show="showMc">
              <a @click="mcPriceCardDownload">{{ $t('tracking.tracking03.dlPriceCard') }}</a>
<!--              <a @click="dlMiniPriceCardDownload">{{ $t('tracking.tracking03.dlMiniPriceCard') }}</a>-->
            </div>
          </div>
        </div>
        <div v-show="spkPriceCalculatorShow && showSpeedPAK" style="background:#eee;padding:10px 20px 20px 20px;">
          <Row style="padding-bottom: 10px">
            <span style="font-weight: bold;">{{this.$t('tracking.tracking03.spkPriceCalculate.gridData.title')}}</span>
          </Row>
          <Row>
            <Card shadow>
              <div class="app-container">
                <div class="filter-container">
                  <Form :label-width="95" :rules="validateRules2" ref="validateRule">
                    <!--第一行-->
                    <Row>
                      <!--始发地-->
                      <i-col :xs="12" :sm="12" :lg="6" >
                        <Form-item :label="$t('tracking.tracking03.spkPriceCalculate.conditions.departure')" prop="departure2">
                          <Select v-model="calculate.departure"  style="width: 100%;">
                            <Option v-for="item in departureList" :key="item.value" :label="item.key" :value="item.value"></Option>
                          </Select>
                        </Form-item>
                      </i-col>
                      <!--目的国-->
                      <i-col :xs="12" :sm="12" :lg="6">
                        <Form-item :label="$t('tracking.tracking03.spkPriceCalculate.conditions.destination')" prop="destination">
                          <el-static-selector
                            class="trueTrackList" style="width: 100%;"

                            ref="arrivalsPriceAreaCodeSelector2"
                            :params="arrivalsPriceAreaCodeSelector"
                            :value="calculate.destination"
                            v-model="calculate.destination" :autoLoad="true" :filterable="true" >
                          </el-static-selector>
                        </Form-item>
                      </i-col>
                      <!--目的区域邮编-->
                      <!--<i-col :lg="6" :sm="12" :xs="12">
                        <div>
                          <Form-item :label="$t('tracking.tracking03.spkPriceCalculate.conditions.zipCode')" prop="zipCode">
                            <Input :placeholder="$t('tracking.tracking03.spkPriceCalculate.prompt.zipCode')"
                                   v-model="calculate.zipCode" />
                          </Form-item>
                        </div>
                      </i-col>-->
                      <!--项目名称-->
                    </Row>

                    <!--第二行-->
                    <Row>
                      <!--下单时间-->
                      <i-col :xs="12" :sm="12" :lg="6">
                        <div>
                          <Form-item :label="$t('tracking.tracking03.spkPriceCalculate.conditions.orderTime')">
                            <DatePicker type="datetime" :options="orderTimeOptions" v-model="calculate.orderTime" :clearable=false></DatePicker>
                          </Form-item>
                        </div>
                      </i-col>

                      <!--是否带电-->
<!--                      <i-col :xs="12" :sm="12" :lg="6">
                        <div>
                          <Form-item :label="$t('tracking.tracking03.spkPriceCalculate.conditions.charged')" prop="charged">
                            <Select v-model="calculate.charged">
                              <Option v-for="item in charged" :value="item.value" :key="item.value">{{ item.key }}</Option>
                            </Select>
                          </Form-item>
                        </div>
                      </i-col>-->

                      <!--重量-->
                      <i-col :xs="12" :sm="12" :lg="6">
                        <div>
                          <Form-item :label="$t('tracking.tracking03.spkPriceCalculate.conditions.weight')" prop="weight">
                            <Input v-model="calculate.weight"
                                   :placeholder="$t('tracking.tracking03.spkPriceCalculate.prompt.weight')" />
                            <span slot="append">g</span>
                          </Form-item>
                        </div>
                      </i-col>
                    </Row>

                    <!--第三行-->
                    <Row>
                      <!--长-->
                      <i-col :xs="12" :sm="12" :lg="6">
                        <div>
                          <Form-item :label="$t('tracking.tracking03.spkPriceCalculate.conditions.length')" prop="length">
                            <Input v-model="calculate.length" />
                            <span slot="append">cm</span>
                          </Form-item>
                        </div>
                      </i-col>

                      <!--宽-->
                      <i-col :xs="12" :sm="12" :lg="6">
                        <div>
                          <Form-item :label="$t('tracking.tracking03.spkPriceCalculate.conditions.width')" prop="width">
                            <Input v-model="calculate.width" />
                            <span slot="append">cm</span>
                          </Form-item>
                        </div>
                      </i-col>

                      <!--高-->
                      <i-col :xs="12" :sm="12" :lg="6">
                        <div>
                          <Form-item :label="$t('tracking.tracking03.spkPriceCalculate.conditions.height')" prop="height">
                            <Input v-model="calculate.height" />
                            <span slot="append">cm</span>
                          </Form-item>
                        </div>
                      </i-col>
                    </Row>
                  </Form>
                </div>
                <div class="panel-container">
                  <Row>
                    <i-col offset="14" span="3">
                      <Button type="primary"   icon="ios-calculator" @click="clickCalculate" :disabled="!this.calculateControl" :loading="requestLoading">
                        <span v-if="!requestLoading">{{this.$t('tracking.tracking03.spkPriceCalculate.calBtnText')}}</span>
                        <span v-else>{{ $t('global.loading') }}</span>
                      </Button>
                    </i-col>
                    <!--下面这行没有span的话，上面的那个button就无法点击，但这个button可以点，不知道是什么bug-->
                    <i-col span="2">
                      <Button type="primary" icon="ios-calculator"
                                    @click="clickReset" >{{$t('tracking.tracking03.spkPriceCalculate.calReset')}}</Button>
                    </i-col>
                  </Row>
                </div>
                <div>
                  <Row>
                    <div>{{this.$t('tracking.tracking03.spkPriceCalculate.tip.remin')}}</div>
                    <div>{{this.$t('tracking.tracking03.spkPriceCalculate.tip.tip1')}}</div>
                    <div>{{this.$t('tracking.tracking03.spkPriceCalculate.tip.tip2Prefix')}}<a @click="clickScroll" target="_blank">{{this.$t('tracking.tracking03.spkPriceCalculate.tip.tip2Middle')}}</a>{{this.$t('tracking.tracking03.spkPriceCalculate.tip.tip2Suffix')}}</div>
                    <div>{{this.$t('tracking.tracking03.spkPriceCalculate.tip.tip3Prefix')}}<a href ="https://www.orangeconnex.com/trackingPackage" target="_blank">{{this.$t('tracking.tracking03.spkPriceCalculate.tip.tip3Middle')}}</a>{{this.$t('tracking.tracking03.spkPriceCalculate.tip.tip3Suffix')}}</div>
                  </Row>
                </div>
              </div>
            </Card>
          </Row>
          <Row style="background:#eee;padding: 10px;"></Row>
          <Row>
            <Card shadow>
              <div class="app-container">
                <div class="panel-container">
                  <!--结果展示表格-->
                  <Row id="grid">
                    <Row>
                      <!--<i-col offset="0" span="8" class="tr"
                             style="background-color: orange;text-align: center;vertical-align:center;color:white;font-size: 25px">
                        <div style="margin-top: 6px">{{this.$t('tracking.tracking03.spkPriceCalculate.gridData.result')}}</div>
                      </i-col>-->
                      <i-col>
                        <div style="margin-top: 6px">{{this.$t('tracking.tracking03.spkPriceCalculate.gridData.result')}}</div>
                      </i-col>

                    </Row>
                    <div v-show="!datagridShow">
                      <Row>
                        <hr />
                      </Row>
                      <Row style="text-align:center;" v-show="!calcuNullShow">
                        <span style="text-align:center;">{{this.$t('tracking.tracking03.spkPriceCalculate.gridData.noResult')}}</span>
                      </Row>
                      <Row style="text-align:center;" v-show="calcuNullShow">
                        <span style="text-align:center;">{{this.$t('tracking.tracking03.spkPriceCalculate.alert.calcuNull')}}</span>
                      </Row>
                    </div>
                    <div v-show="datagridShow">
                      <Row style="padding-bottom: 20px">
                        <hr />
                      </Row>
                      <!--表格标题行-->
                      <Row>
                        <i-col class="priceTr" span="7" >
                          <div class="priceEsHeader2222"><b>{{this.$t('tracking.tracking03.spkPriceCalculate.conditions.productOuter')}}</b></div>
                        </i-col>

                        <i-col span="3" class="priceTr">
                          <div class="priceEsHeader2222"><b>{{this.$t('tracking.tracking03.spkPriceCalculate.conditions.calWeight')}}</b></div>
                        </i-col>

                        <i-col span="3" class="priceTr">
                          <div class="priceEsHeader2222">
                            <span>
                              <b>{{this.$t('tracking.tracking03.spkPriceCalculate.conditions.chargeType')}}</b>
                            </span>
                            <span>
                              <Tooltip   placement="top" transfer >
                                 <span>ⓘ</span>
                                 <div slot="content" style="white-space: normal;word-break: normal;width: 240px">
                                   <p>{{this.$t('tracking.tracking03.spkPriceCalculate.tip.toolTip5')}}</p>
                                    <p>{{this.$t('tracking.tracking03.spkPriceCalculate.tip.toolTip1')}}</p>
                                    <p>{{this.$t('tracking.tracking03.spkPriceCalculate.tip.toolTip2')}}</p>
                                    <p>{{this.$t('tracking.tracking03.spkPriceCalculate.tip.toolTip3')}}</p>
                                   <!--                                    <p>{{this.$t('tracking.tracking03.spkPriceCalculate.tip.toolTip4')}}</p>-->
                                    <p>{{this.$t('tracking.tracking03.spkPriceCalculate.tip.toolTip6')}}</p>
                                    <p>{{this.$t('tracking.tracking03.spkPriceCalculate.tip.toolTip7')}}</p>
                                    <p>{{this.$t('tracking.tracking03.spkPriceCalculate.tip.toolTip8')}}</p>
                                    <p>{{this.$t('tracking.tracking03.spkPriceCalculate.tip.toolTip9')}}</p>
                                 </div>
                              </Tooltip>
                            </span>
                          </div>
                        </i-col>
                        <i-col class="priceTr" span="3"  >
                          <div class="priceEsHeader2222"><b>{{this.$t('tracking.tracking03.spkPriceCalculate.conditions.charged')}}</b></div>
                        </i-col>
                        <i-col class="priceTr" span="4"  >
                          <div class="priceEsHeader2222"><b>{{this.$t('tracking.tracking03.spkPriceCalculate.gridData.total')}}</b></div>
                        </i-col>
                       <i-col class="priceTr" span="2"  >
                          <div class="priceEsHeader2222"><b>{{this.$t('tracking.tracking03.spkPriceCalculate.gridData.remark')}}</b></div>
                        </i-col>
                      </Row>

                      <Row v-for="(item, index) in this.gridData" :key="index">
                        <i-col class="priceTd" span="7">
                          <div class="priceEsHeader2222" v-if="language222 === 'en-US'">{{ item.productOuterNameEn }}</div>
                          <div class="priceEsHeader2222" v-if="language222 === 'zh-CN'">{{ item.productOuter}}</div>
                        </i-col>

                        <i-col span="3" class="priceTd">
                          <div class="priceEsHeader2222">{{item.weight}} g</div>
                        </i-col>

                        <i-col span="3" class="priceTd">
                          <div class="priceEsHeader2222">{{item.chargeType}}</div>
                        </i-col>

                        <i-col span="3" class="priceTd">
                          <div class="priceEsHeader2222" v-if="item.batteryType === 0">{{ $t('tracking.tracking03.list.yes') }}</div>
                          <div class="priceEsHeader2222" v-if="item.batteryType === 1">{{ $t('tracking.tracking03.list.no') }}</div>
                        </i-col>

                        <i-col class="priceTd" span="4">
                          <div class="priceEsHeader2222">{{item.totalCost}} {{item.currency}}</div>
                        </i-col>
                        <i-col span="2" class="priceTd">
                          <div class="priceEsHeader2222" v-if="language222 === 'en-US'">{{item.flowRemarkEn}}</div>
                          <div class="priceEsHeader2222" v-if="language222 === 'zh-CN'">{{item.flowRemark}}</div>
                        </i-col>
                      </Row>
                      <Row style="padding-top: 10px"></Row>
<!--                      <Row>
                        <div>{{this.$t('tracking.tracking03.spkPriceCalculate.tip.remin')}}</div>
                        <div>{{this.$t('tracking.tracking03.spkPriceCalculate.tip.tip1')}}</div>
                        <div>{{this.$t('tracking.tracking03.spkPriceCalculate.tip.tip2')}}</div>
                        <div>{{this.$t('tracking.tracking03.spkPriceCalculate.tip.tip3Prefix')}}<a href ="https://www.orangeconnex.com/trackingPackage" target="_blank">{{this.$t('tracking.tracking03.spkPriceCalculate.tip.tip3Middle')}}</a>{{this.$t('tracking.tracking03.spkPriceCalculate.tip.tip3Suffix')}}</div>
                      </Row>-->
                    </div>
                  </Row>
                </div>
              </div>
            </Card>
          </Row>
        </div>
        <div></div>
        <!--table-->
        <div id="clickShow">
          <!--spk cn价卡图片-->
          <img v-show="showSpeedPAK && (showSpeedPAKcn || spkPriceCalculatorShow)" :src="tracking03" style="width:100%;" />
          <!--spk hk价卡图片-->
          <img v-show="showSpeedPAK && (showSpeedPAKhk || spkPriceCalculatorShow)" :src="hkPriceImg" style="width:100%;" />
        </div>
        <img v-show="showSpeedFreight" :src="spfImg" style="width:100%;" />
        <!-- <img v-show="showSpeedFreightAsia" :src="spfAsiaImg" style="width:100%;" /> -->
        <img v-show="showMc" :src="mcImg" style="width:100%;" />

      </div>
    </div>
  </div>
</template>

<script>
  import NewAreaSelector from '../../components/selectors/NewAreaSelector.vue'
  import StaticSelector from '../../components/selectors/StaticSelector.vue'
  import ElStaticSelector from '../../components/selectors/ElStaticSelector.vue'
export default {
  components: {
    NewAreaSelector,
    StaticSelector,
    ElStaticSelector
  },
  name: 'tracking03',
  data() {
    const validateZipCode = (rule, value, callback) => {
      if (this.flags.reset) {
        //如果是重置表单操作，清除所有提示，否则重置会触发非空校验，下拉框的校验都是onchange
        return callback();
      }
      value = this.calculate[rule.field];
      if(value !== 0 && !value){
        let errorMsg = '该项为必填项'
        if (rule.field === 'zipCode'){
          errorMsg = '请输入邮编'
        }
        return callback(new Error(errorMsg))
      }
      if (value.toString().length > 10){
        return callback(new Error('输入的邮编过长'));
      }
      let xsd = value.toString().indexOf('.')
      if (xsd > 0) {
        return callback(new Error('请输入数字'));
      }
      let reg = /^[0-9a-zA-Z\s+]+$/
      // value = value - 0;
      if (!value.match(reg)) {
        return callback(new Error('只可以输入字母数字空格'));
      }
      return callback();

    };
    const valiWeightNumber = (rule, value, callback) => {
      if (this.flags.reset) {
        //如果是重置表单操作，清除所有提示，否则重置会触发非空校验，下拉框的校验都是onchange
        return callback();
      }
      value = this.calculate[rule.field];
      if(value !== 0 && !value){
        let errorMsg = '该项为必填项'
        return callback(new Error(errorMsg))
      }
      value = value - 0;
      if (isNaN(value)) {
        return callback(new Error('请输入数字'));
      }
      if (typeof value === 'number') {
        if (value < 0) {
          return callback(new Error('最小可输入0'));
        }
        if (value > 99999.9999) {
          return callback(new Error('最大可输入5位整数,5位小数'));
        }
        let xsd = value.toString().split('.');
        if (xsd.length > 1) {
          if (xsd[1].length > 4) {
            return callback(new Error('最长可以输入四位小数'));
          }
        }
        return callback();
      } else {
        return callback(new Error('请输入数字'));
      }
    };
    const validateNumber = (rule, value, callback) => {
      if (this.flags.reset) {
        //如果是重置表单操作，清除所有提示，否则重置会触发非空校验，下拉框的校验都是onchange
        return callback();
      }
      value = this.calculate[rule.field];
      if(value !== 0 && !value){
        let errorMsg = '该项为必填项'
        if (rule.field === 'zipCode'){
          errorMsg = '请输入邮编'
        }
        return callback(new Error(errorMsg))
      }
      value = value - 0;
      if (isNaN(value)) {
        return callback(new Error('请输入数字'));
      }
      if (typeof value === 'number') {
        if (value < 0) {
          return callback(new Error('最小可输入0'));
        }
        if (value > 9999.9999) {
          return callback(new Error('最大可输入4位整数,4位小数'));
        }
        let xsd = value.toString().split('.');
        if (xsd.length > 1) {
          if (xsd[1].length > 4) {
            return callback(new Error('最长可以输入四位小数'));
          }
        }
        return callback();
      } else {
        return callback(new Error('请输入数字'));
      }
    };
    const validateNull = (rule, value, callback) => {
      if (this.flags.reset) {
        //如果是重置表单操作，清除所有提示，否则重置会触发非空校验，下拉框的校验都是onchange
        return callback();
      }
      value = this.calculate[rule.field];
      if(value !== 0 && !value){
        let errorMsg = '该项为必填项'
        if (rule.field === 'destination'){
          errorMsg = '请选择目的国'
        }
        return callback(new Error(errorMsg))
      }
      return callback()
    };
    //校验部分
    const validateIsNumber = (rule, value, callback) => {
      //仅包含数字和小数点才接着做后续校验
      if (/^[0-9.]*$/.test(value)) {
        if (/^[0]*$/.test(value)||/^[0]*[.][0]*$/.test(value)) {
          this.flags[rule.field] = false;
          return callback(new Error(this.$t('tracking.tracking03.spkPriceCalculate.alert.notZero')));
        } else if (!/^[0-9]*$/.test(value) && !/^.*[.]{1}.{1,4}$/.test(value)) {
          //若不包含小数点则直接下一级验证，若含小数点，验证小数位数
          this.flags[rule.field] = false;
          return callback(new Error(this.$t('tracking.tracking03.spkPriceCalculate.alert.decimalRange0to4')));
        } else if (/^[0]{1}[.][0-9]*$/.test(value) || /^[1-9]{1}[0-9]*[.][0-9]*$/.test(value) || /^[1-9]{1}[0-9]*$/.test(value)) {
          //验证是否是符合规则的有效小数或整数
          this.flags[rule.field] = true;
          return callback();
        }
      }
      this.flags[rule.field] = false;
      return callback(new Error(this.$t('tracking.tracking03.spkPriceCalculate.alert.invalid')));
    };

    const validateNotNull = (rule, value, callback) => {
      // debugger
      if (this.flags.reset) {
        //如果是重置表单操作，清除所有提示，否则重置会触发非空校验，下拉框的校验都是onchange
        return callback();
      }
      //直接用value会是undefined，应该是iview的bug，直接用iview自带验证也有很多bug
      value = this.calculate[rule.field];
      //去除输入空格的空格再校验，若下拉框传来的值是object的，不用去空格
      if (typeof value === 'object' ? !value : value.trim() === '') {
        this.flags[rule.field] = false;
        return callback(new Error(this.$t('tracking.tracking03.spkPriceCalculate.alert.notNull')));
      } else {
        //嵌套实现多重验证，直接往原生的验证数组里添加无法实现，不知道为啥
        if (rule.type === 'number') {
          return validateIsNumber(rule, value.trim(), callback);
        }
        this.flags[rule.field] = true;
        //必须有这个，不然会加载一个转圈的gif，会挡到输入值
        return callback();
      }
      return callback()
    };
    return {
      orderTimeOptions:{
        disabledDate (date) {
          let befor = date && date.valueOf() < Date.now() - 86400000
          let after = date.valueOf() > (Date.now() + (1000 * 60 * 60 * 24 *3))
          return befor || after;
        }
      },
      requestLoading:false,
      arrivalsPriceAreaCodeSelector: {
        emptyText: '',
        sellectorUser: 0,
      },
      calcuNullShow:false,
      datagridShow:false,
      priceCalcMouseOver:false,
      dlpriceCalcMouseOver:false,
      hkpriceCalcMouseOver:false,
      //控制按钮点击的flag
      flags: {
        departure: '',
        destination: '',
        weight: '',
        length: '',
        width: '',
        height: '',
        charged:'',
        //用于重置数据时跳过验证
        reset: false,
      },
      isMC:false,
      gridData: [
      ],
      departure2:null,
      calculate: {
        departureEn:'',
        departure: 'CN',
        destination: null,
        destinationProvince:'',
        orderTime: new Date(),
        charged: '1',
        incoterm: '',
        product: '',
        weight: '',
        length: '',
        width: '',
        height: '',
        productInnerId: '',
        project:'',
        zipCode:'',
        addressValidation:null,
        letter:null,
        channelCode:[]
      },
      charged: [
        {
          key: this.$t('tracking.tracking03.list.yes'),
          value: '0'
        },
        {
          key: this.$t('tracking.tracking03.list.no'),
          value: '1'
        }
      ],
      spkPriceCalculatorShow: false,
      showSpeedPAK: true,
      showSpeedPAKcn: true,
      showSpeedPAKhk: false,
      showSpeedFreight: false,
      showSpeedFreightAsia: false,
      showCf: false,
      showMc:false,
      trackingProductsCn: process.env.OC_API + '/website/file/tracking03_pic.jpg?1',
      trackingProductsEn: process.env.OC_API + '/website/file/tracking03_EN.jpg?2',
      hkPriceImgCn: process.env.STATIC_API + '/file/eBayHKCN.jpg?1',
      hkPriceImgEn: process.env.STATIC_API + '/file/eBayHKEN.jpg?2',
      spfImgCn: process.env.OC_API + '/website/file/cfPrice_pic.jpg?1',
      spfImgEn: process.env.OC_API + '/website/file/cfPrice_EN.jpg?2',
      spfAsiaImgCn: process.env.OC_API + '/website/file/spfPricePic_ZH.jpg?1',
      spfAsiaImgEn: process.env.OC_API + '/website/file/spfPricePic_EN.jpg?2',
      mcImgCn: process.env.OC_API + '/website/file/mcPricePic_ZH.jpg?2',
      mcImgEn: process.env.OC_API + '/website/file/mcPricePic_EN.jpg?2',
      //表单各输入条件的校验规则
      validateRules: {
        departure: [
          {validator: validateNotNull, trigger: 'change', required: true}
        ],
        destination: [
          {validator: validateNotNull, trigger: 'change', required: true}
        ],
        project: [
          {validator: validateNotNull, trigger: 'change', required: true}
        ],
        product: [
          {validator: validateNotNull, trigger: 'change', required: true}
        ],
        weight: [
          {validator: validateNotNull, trigger: 'blur', required: true, type: 'number'}
        ],
        length: [
          {validator: validateNotNull, trigger: 'blur', required: true, type: 'number'}
        ],
        width: [
          {validator: validateNotNull, trigger: 'blur', required: true, type: 'number'}
        ],
        height: [
          {validator: validateNotNull, trigger: 'blur', required: true, type: 'number'}
        ],
        zipCode: [
          {validator: validateNotNull, trigger: 'blur', required: true, type: 'number'}
        ],
        charged: [
          {validator: validateNotNull, trigger: 'change', required: true}
        ]
      },
      validateRules2: {
        departure: [
          {validator: validateNull, trigger: 'change', required: true}
        ],
        destination: [
          {validator: validateNull, trigger: 'change', required: true}
        ],
        weight: [
          {validator: valiWeightNumber, trigger: 'change', required: true, type: 'number'}
        ],
        length: [
          {validator: validateNumber, trigger: 'change', required: true, type: 'number'}
        ],
        width: [
          {validator: validateNumber, trigger: 'change', required: true, type: 'number'}
        ],
        height: [
          {validator: validateNumber, trigger: 'change', required: true, type: 'number'}
        ],
        zipCode: [
          {validator: validateZipCode, trigger: 'change', required: true, type: 'number'}
        ],
        charged: [
          {validator: validateNull, trigger: 'change', required: true}
        ]
      },
    }
  },
  computed: {
    tracking03() {
      if (this.$i18n.locale === 'zh-CN') {
        return this.trackingProductsCn + new Date().getTime()
      } else if (this.$i18n.locale === 'en-US') {
        return this.trackingProductsEn + new Date().getTime()
      }
    },
    hkPriceImg() {
      if (this.$i18n.locale === 'zh-CN') {
        return this.hkPriceImgCn + new Date().getTime()
      } else if (this.$i18n.locale === 'en-US') {
        return this.hkPriceImgEn + new Date().getTime()
      }
    },
    spfImg() {
      if (this.$i18n.locale === 'zh-CN') {
        return this.spfImgCn + new Date().getTime()
      } else if (this.$i18n.locale === 'en-US') {
        return this.spfImgEn + new Date().getTime()
      }
    },
    spfAsiaImg() {
      if (this.$i18n.locale === 'zh-CN') {
        return this.spfAsiaImgCn + new Date().getTime()
      } else if (this.$i18n.locale === 'en-US') {
        return this.spfAsiaImgEn + new Date().getTime()
      }
    },
    mcImg() {
      if (this.$i18n.locale === 'zh-CN') {
        return this.mcImgCn + new Date().getTime()
      } else if (this.$i18n.locale === 'en-US') {
        return this.mcImgEn + new Date().getTime()
      }
    },
    //校验是否已填写所有必填项
    calculateControl: function () {
      return this.calculate.destination && this.calculate.weight && this.calculate.length &&
        this.calculate.width && this.calculate.height && this.calculate.departure && this.calculate.charged;
    },
    departureList(){
      let options = [
        {
          key: this.$t('tracking.tracking03.list.cn'),
          value: 'CN'
        },
        {
          key: this.$t('tracking.tracking03.list.hk'),
          value: 'HK'
        }
      ]
      return options
    },
    language222(){
      return this.$i18n.locale
    },
  },
  watch:{
    '$i18n.locale': {
      handler: function () {
        // this.clickReset()
        // this.loaddeparture()
        this.$refs.arrivalsPriceAreaCodeSelector2.loadData()
        this.datagridShow = false
      },
      deep: true
    },

  },
  methods: {
    toSpeedPAK() {
      this.showSpeedPAK = true
      this.spkPriceCalculatorShow = false
      this.showSpeedPAKcn = true
      this.showSpeedPAKhk = false
      this.showSpeedFreight = false
      this.showSpeedFreightAsia = false
      this.showCf = false
      this.showMc = false
    },
    toCf() {
      this.showSpeedPAK = false
      this.showCf = true
    },
    toSpeedFreight() {
      this.showSpeedPAK = false
      this.showSpeedFreight = true
      this.showSpeedFreightAsia = false
      this.showMc = false
    },
    toSpeedFreightAsia() {
      this.showSpeedPAK = false
      this.showSpeedFreight = false
      this.showSpeedFreightAsia = true
      this.showMc = false
    },
    toMc(){
      this.showSpeedPAK = false
      this.showSpeedFreight = false
      this.showSpeedFreightAsia = false
      this.showMc = true
    },
    dlPriceCardDownload() {
      this.spkPriceCalculatorShow = false
      this.showSpeedPAKhk = false
      this.showSpeedPAKcn = true
      if (this.$i18n.locale === 'zh-CN') {
        //中文
        window.open(process.env.OC_API + '/website/file/SpeedPAK_CHN_CN.xlsx?1')
      } else if (this.$i18n.locale === 'en-US') {
        //英文
        window.open(process.env.OC_API + '/website/file/SpeedPAK_CHN_EN.xlsx?2')
      }
    },
    mcPriceCardDownload() {
      if (this.$i18n.locale === 'zh-CN') {
        //中文
        window.open(process.env.OC_API + '/website/file/MultiChannel_CHN_CN.xlsx?1')
      } else if (this.$i18n.locale === 'en-US') {
        //英文
        window.open(process.env.OC_API + '/website/file/MultiChannel_CHN_EN.xlsx?2')
      }
    },
    hkPriceCardDownload() {
      this.spkPriceCalculatorShow = false
      this.showSpeedPAKhk = true
      this.showSpeedPAKcn = false
      if (this.$i18n.locale === 'zh-CN') {
        //中文
        window.open(process.env.OC_API + '/website/file/SpeedPAK_HKG_CN.xlsx?1')
      } else if (this.$i18n.locale === 'en-US') {
        //英文
        window.open(process.env.OC_API + '/website/file/SpeedPAK_HKG_EN.xlsx?2')
      }
    },
    dlMiniPriceCardDownload() {
      if (this.$i18n.locale === 'zh-CN') {
        //中文
        window.open(process.env.OC_API + '/website/file/SPK_Mini_CHN_CN.xlsx?1')
      } else if (this.$i18n.locale === 'en-US') {
        //英文
        window.open(process.env.OC_API + '/website/file/SPK_Mini_CHN_EN.xlsx?2')
      }
    },
    //spf中国价卡
    spfPriceCardDownload() {
      if (this.$i18n.locale === 'zh-CN') {
        //中文
        window.open(process.env.OC_API + '/website/file/SpeedFreight_CHN_CN.xlsx?1')
      } else if (this.$i18n.locale === 'en-US') {
        //英文
        window.open(process.env.OC_API + '/website/file/SpeedFreight_CHN_EN.xlsx?2')
      }
    },
    //spf东南亚价卡
    spfAsiaPriceCardDownload() {
      if (this.$i18n.locale === 'zh-CN') {
        //中文
        window.open(process.env.OC_API + '/website/file/SpeedFreight_SEA_CN.xlsx?1')
      } else if (this.$i18n.locale === 'en-US') {
        //英文
        window.open(process.env.OC_API + '/website/file/SpeedFreight_SEA_EN.xlsx?2')
      }
    },
    spkPriceCalculator(){
      this.spkPriceCalculatorShow = !this.spkPriceCalculatorShow

    },
    addSelectDestinationChange: function (data) {
      if (data && data.length > 0) {
        this.calculate.destination = data[0];
      } else {
        this.calculate.destination = '';
      }

      if (data && data.length > 1) {
        this.calculate.destinationProvince = data[1];
      } else {
        this.calculate.destinationProvince = '';
      }
      // this.initInnerProduct()
    },
    clickCalculate() {
      this.$refs.validateRule.validate((valid) => {
        //表单校验
        if (!valid) {
          return;
        }
        this.calcuNullShow = false
        this.requestLoading=true
        let volumeWeight = ''; //体积重
        let chareType = this.$t('tracking.tracking03.spkPriceCalculate.gridData.chareType_actual'); //计费方式  实重
        let length = this.calculate.length;
        let width = this.calculate.width;
        let height = this.calculate.height;
        let weightTemp = this.calculate.weight;
        //提取目的国下拉框组件的值拼接字面值
        /*let areaList = this.$refs.initSelectCascaderData2Ref.areaList;
        let currArea = this.$refs.initSelectCascaderData2Ref.currArea;
        let label = '';
        for (let area of areaList) {
          if (area.value === currArea[0]) {
            label = area.label;
          }
          if (area.children) {
            for (let child of area.children) {
              if (child.value === currArea[1]) {
                label = label + '-' + child.label;
              }
            }
          }
        }*/
        // let departure = this.calculate.departure === 'CN' ? this.$t('tracking.tracking03.spkPriceCalculate.list.cn') : this.$t('tracking.tracking03.spkPriceCalculate.list.hk');
        //计算逻辑步骤1
        if (length >= 40 || width >= 40 || height >= 40) {
          //计算逻辑步骤2，计抛条件
          const volume = length * width * height;
          volumeWeight = Math.round(volume / 6 * 10000) / 10000;
          if (volume / 7.8 > weightTemp) {
            weightTemp = volume / 6 - weightTemp * 0.3;
            chareType = this.$t('tracking.tracking03.spkPriceCalculate.gridData.chareType_weighting'); //计抛重
          }
        }
        //墨西哥路向特殊处理
        if ( this.calculate.destination === 'MX') {
          const volume = (length * width * height)/6;
          if (volume > weightTemp) {
            chareType = this.$t('tracking.tracking03.spkPriceCalculate.gridData.chareType_weighting');  //计抛重
          }
          weightTemp = volume > weightTemp ? volume : weightTemp;
          volumeWeight = Math.round(volume * 10000) / 10000;
        }
        //重量最多保留四位小数
        weightTemp = Math.round(weightTemp * 10000) / 10000;
        let orderTimeTmp = this.calculate.orderTime ? new Date(this.calculate.orderTime).getTime() : null
        //计算逻辑步骤3,组装请求参数并请求接口
        let params = {
          // productId: this.calculate.product,
          // batteryType: this.calculate.charged,
          // batteryType: 2, //全部
          incoterm : 0,
          departure: this.calculate.departure,
          destination: this.calculate.destination,
          destinationProvince: this.calculate.destinationProvince,
          orderTime: orderTimeTmp,
          packageWeight: weightTemp,
          packageWeightUnit: 0,
          // productInnerId: this.calculate.productInnerId,
          projectCode: 'eBay',
          zipCode:this.calculate.zipCode,
          letter:this.calculate.letter,
          addressValidation: this.calculate.addressValidation,
          channelCode: this.calculate.channelCode,
          language: this.$i18n.locale
        };
        this.datagridShow = false
        this.gridData = [];
        // http.mergePostAndPut(process.env.BASE_API + '/aquarius-trace/price-estimate/v2/estimate', params).then((res) => {
        this.$store.dispatch("priceEstimateCalculate", params ).then(res => {
          if (res.success ) {
            if(res.priceEstimateCalculateResult.errorCode === '5001'){
              this.calcuNullShow = true
            } else {
              // this.gridData[0].departure = departure;
              // this.gridData[0].destination = label;
              // this.gridData[0].weight = weightTemp+' g';
              // let history = res.result.history;
              // let current = res.result.current;
              // //价格四舍五入保留两位小数
              // this.gridData[0].totalCost = history.currency === 'CNY' ? '￥ ' + Math.round(history.freight * 100) / 100 : history.currency + ' ' + Math.round(history.freight * 100) / 100;
              // this.gridData[1].totalCost = current.currency === 'CNY' ? '￥ ' + Math.round(current.freight * 100) / 100 : current.currency + ' ' + Math.round(current.freight * 100) / 100;
              this.gridData = res.priceEstimateCalculateResult.result.zero;
              if(this.gridData.length > 0){
                this.datagridShow = true
              }
              for (let i = 0; i < this.gridData.length; i++) {
                this.gridData[i].calWeight130 = Math.round(this.calculate.weight * 1.3 * 10000) / 10000;
                // 取输入框长宽高，如有单边大于等于40，则计入体积重公式得出体积重
                this.gridData[i].volumeWeight = volumeWeight === ''? volumeWeight : volumeWeight + ' g';
                this.gridData[i].chargeType = chareType;
                if (this.gridData[i].flowRemark === '轻小件'){
                  this.gridData[i].flowRemarkEn = 'lite'
                }else{
                  this.gridData[i].flowRemarkEn = this.gridData[i].flowRemark
                }
              }
            }

          } else {
            /*this.$Message.error({
              content: res.errorMsg,
              type: 'error',
              duration: 3,
              closable: true
            });*/
          }
          this.requestLoading=false
        });
      });
    },
    clickReset() {
      this.flags.reset = true;
      this.initData();
      //重置目的国选择组件
      /*this.$refs.initSelectCascaderData2Ref.currArea = [];
      this.$refs.initSelectCascaderData2Ref.currCit = [];
      this.$refs.initSelectCascaderData2Ref.currCou = [];*/
      //调用表单验证配合reset的flag来清除之前的验证留下来的错误提示
      this.$refs.validateRule.validate(() => {
      });
      this.$nextTick(() => {
        this.flags.reset = false;
      });
      /*setTimeout(() => {
        this.flags.reset = false;
      }, 200);*/
    },
    //初始化各条件的默认数据
    initData() {
      this.calculate.departure = 'CN';
      this.calculate.product = '0';
      this.calculate.destination = null;
      this.calculate.orderTime = new Date();
      this.calculate.charged = 1;
      this.calculate.incoterm = 0;
      this.calculate.weight = '';
      this.calculate.productInnerId = '';
      this.calculate.length = '';
      this.calculate.width = '';
      this.calculate.height = '';
      this.$nextTick(() => {
        this.calculate.project = 'eBay';
      });
      this.flags.departure = true;
      this.flags.destination = false;
      this.flags.weight = false;
      this.flags.product = true;
      this.flags.length = true;
      this.flags.width = true;
      this.flags.height = true;
      this.flags.project = this.flags.reset;
    },
    mouseOver(){
      this.priceCalcMouseOver = true
    },
    mouseLeave(){
      this.priceCalcMouseOver = false
    },
    dlmouseOver(){
      this.dlpriceCalcMouseOver = true
    },
    dlmouseLeave(){
      this.dlpriceCalcMouseOver = false
    },
    hkmouseOver(){
      this.hkpriceCalcMouseOver = true
    },
    hkmouseLeave(){
      this.hkpriceCalcMouseOver = false
    },
    clickScroll(){
      document.getElementById('clickShow').scrollIntoView()
    }
  }
}
</script>



// WEBPACK FOOTER //
// tracking03.vue?97579834